(function () {
  const FILTER_ID_PREFIX = 'FIL-K-';

  const HEADING_SELS = [`.boost-sd__filter-option-heading`, '.boost-sd__filter-tree-vertical-toolbar-middle', `.boost-sd__filter-option-item-label`];
  const VALUE_SELS = ['.boost-sd__refine-by-vertical-refine-by-option', '.boost-sd__refine-by-vertical-refine-by-value', '.boost-sd__filter-option-mobile-items-selected', '.boost-sd__filter-option-item-label']

  const config = window.boostFilterTranslations;
  if (!config) return;

  // Překlady skladové dostupnosti 21.9.26 start
  const stockLanguage = (document.documentElement.lang || 'cs')
    .toLowerCase()
    .split('-')[0];

  const stockTranslations = {
    cs: ['Pouze skladem', 'Není skladem'],
    sk: ['Iba skladom', 'Nie je skladom'],
    pl: ['Tylko dostępne', 'Niedostępne'],
    hu: ['Csak raktáron', 'Nincs raktáron'],
    en: ['In stock only', 'Out of stock']
  };

  const stockText =
    stockTranslations[stockLanguage] || stockTranslations.en;

  config.specialFilters = config.specialFilters || {};

  Object.assign(config.specialFilters, {
    'in stock': stockText[0],
    'out of stock': stockText[1]
  });
  // Překlady skladové dostupnosti 21.9.26 end

  const names = config.names || {};
  const values = config.values || {};
  const specialFilters = config.specialFilters || {};

  function replaceTextNode(el, oldText, newText) {
    for (const node of el.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === oldText) {
        node.textContent = newText;
        return;
      }
    }
  }

  function getElementsToTranslate(selectors) {
    const elements = [];
    for (const sel of selectors) {
      elements.push(...document.querySelectorAll(sel));
    }
    return elements;
  }

  // Extract filter ID from FIL-K-{filterId}-... format
  function extractFilter(text) {
    if (!text.startsWith(FILTER_ID_PREFIX)) return null;
    const filterWithoutPrefix = text.slice(6);
    const filterParts = filterWithoutPrefix.split('-');

    return {
      key: filterParts[0],
      value: filterParts.slice(1).join('-'),
    }
  }

  function translateFilters() {
    // Přeložit název skladového filtru v souhrnu výběru 21.9.26 start
    const selectedStockLanguage = (document.documentElement.lang || 'cs')
      .toLowerCase()
      .split('-')[0];

    const selectedStockTitles = {
      cs: 'Dostupnost',
      sk: 'Dostupnosť',
      pl: 'Dostępność',
      hu: 'Elérhetőség',
      en: 'Availability'
    };

    const selectedStockTitle =
      (selectedStockTitles[selectedStockLanguage] || 'Availability') + ':';

    document.querySelectorAll(
      '.boost-sd__refine-by-vertical-refine-by-option' +
      '[metadata*="pf_m_::custom::inventory_status"]'
    ).forEach(function (label) {
      if (label.textContent.trim() !== selectedStockTitle) {
        label.textContent = selectedStockTitle;
      }

      const displayedTitle = selectedStockTitle + ' ';

      if (label.getAttribute('data-clean-label') !== displayedTitle) {
        label.setAttribute('data-clean-label', displayedTitle);
      }
    });
    // Přeložit název skladového filtru v souhrnu výběru 21.9.26 end

    // Translate filter headings
    const headingsToTranslate = getElementsToTranslate(HEADING_SELS);
    for (const heading of headingsToTranslate) {
      const current = heading.textContent.trim();

      if (specialFilters[current]) {
        replaceTextNode(heading, current, specialFilters[current]);
        continue;
      }

      const filter = extractFilter(current);
      if (!filter) continue;

      const filterId = filter.key;
      const translated = names[filterId];
      if (translated) {
        const filterName = translated.unit ? `${translated.name} [${translated.unit}]` : translated.name;
        const shownFilterName = current.endsWith(':') ? `${filterName}:` : filterName;
        replaceTextNode(heading, current, shownFilterName);
      }
    }

    // Translate filter option values
    const valuesToTranslate = getElementsToTranslate(VALUE_SELS);
    for (const label of valuesToTranslate) {
      const text = label.textContent.trim();
      const filterParts = extractFilter(text);
      const filterValue = filterParts ? filterParts.value : text;

      if (filterValue.startsWith('id-')) {
        // Translatable value: look up in metafield map
        const id = filterValue.substring(3);
        if (values[id]) {
          replaceTextNode(label, text, values[id]);
        }
      } else if (filterValue) {
        const valueToReplaceWith = specialFilters[filterValue] ? specialFilters[filterValue] : filterValue;
        replaceTextNode(label, text, valueToReplaceWith);
      }
    }
  }

  let scheduled = false;
  function scheduleTranslate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      translateFilters();
    });
  }

  const observer = new MutationObserver(scheduleTranslate);
  observer.observe(document.body, { childList: true, subtree: true });
  translateFilters();
})();
